import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import AccountBalance from "./components/jifen/AccountBalance";
import ReputationProfile from "./components/jifen/ReputationProfile";
import ViolationReport from "./components/jifen/ViolationReport";
import Recharge from "./components/jifen/Recharge";
import SiteFooter from "./components/SiteFooter";

function App_jifen() {
  const [currentView, setCurrentView] = useState("account");
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // 初始状态直接从 localStorage 检查
    const token = localStorage.getItem("access_token");
    return !!token;
  });
  const navigate = useNavigate();

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  // 如果未登录，重定向到登录页面
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar
        isLoggedIn={isLoggedIn}
        onLogout={handleLogout}
      />

      <main className="flex-1 w-full max-w-7xl mx-auto px-4 py-8">

        {/* 主要内容区域 */}
        <Routes>
          <Route path="/account" element={<AccountBalance />} />
          <Route path="/reputation" element={<ReputationProfile />} />
          <Route path="/violation" element={<ViolationReport />} />
          <Route path="/recharge" element={<Recharge />} />
          <Route path="/" element={<Navigate to="account" replace />} />
          <Route path="*" element={<Navigate to="account" replace />} />
        </Routes>
      </main>

      <SiteFooter />
    </div>
  );
}

export default App_jifen;